export default "__VITE_ASSET__CLTfQjnT__ 500w";